import { useQuery } from '@tanstack/react-query'

const errorMsgs = [
  `Nothing found for this Reference ID.`,
  `Something went wrong. Please contact support or try again later.`,
  `Our systems are down. Please try again at a later time.`,
]

export const fetchInsuranceDocument = async (refId, agencyId) => {
  const response = await fetch(
    `${process.env.GATSBY_API_URL}/unitrac/property/insurance-document?ReferenceId=${refId}&AgencyId=${agencyId}&Username=username`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'true'
      }
    }
  )

  // Handle different status codes
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error(errorMsgs[0])
    }
    if (response.status === 503) {
      throw new Error(errorMsgs[2])
    }
    if (response.status >= 500) {
      throw new Error(errorMsgs[1])
    }
    if (response.status >= 300) {
      throw new Error(errorMsgs[0])
    }
  }

  const data = await response.json()
  
  // Process insurance document data
  if (data.RequiredCoverageType === 'HAZARD' &&
      (data.IsMortgage === 'true' || data.IsMortgage === true)) {
    data.MustAttachProofOfInsurance = true
  }

  return data
}

export const useInsuranceDocumentQuery = (refId, agencyId) => {
  const query = useQuery({
    queryKey: ['insuranceDocument', refId, agencyId],
    queryFn: () => fetchInsuranceDocument(refId, agencyId),
    enabled: !!(refId && agencyId),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000, 
  })

  return query
}

